import moment from 'moment';
import React, {Component} from 'react';
import { FormattedMessage } from "react-intl";
import isSameDay from '../../utils/isSameDay';


export default class ShortcutPlugin extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const today = moment();
        const yesterday = moment().subtract(1, 'day');
        const presets = [
            {
                    text: <FormattedMessage id="Today"/>,
                    start: today,
                    end: today,
                    presetDate: "TODAY"
            },
            {
                    text: <FormattedMessage id="Yesterday"/>,
                    start: yesterday,
                    end: yesterday,
                    presetDate: "YESTERDAY"
            },
            {
                    text: <FormattedMessage id="Last 7 Days"/>,
                    start: moment().subtract(1, 'week'),
                    end: today,
                    presetDate: "LAST_7_DAYS"
            },
            {
                    text: <FormattedMessage id="Last 30 Days"/>,
                    start: moment().subtract(30, 'day'),
                    end: today,
                    presetDate: "LAST_30_DAYS"
            },
            {
                    text: <FormattedMessage id="Current Month"/>,
                    start: moment().startOf('month'),
                    end: moment().endOf('month'),
                    presetDate: "CURRENT_MONTH"
            },
            {
                    text: <FormattedMessage id="Last Month"/>,
                    start: moment().subtract(1, 'month').startOf('month'),
                    end: moment().subtract(1, 'month').endOf('month'),
                    presetDate: "LAST_MONTH"
            }
        ];

    const startDate = !this.props.showGlobal || (this.props.showGlobal && this.props.chart.useGlobal) ? moment(this.props.analyticsDatePicker.globalFromTime) : moment(this.props.chart.fromTime);
    const endDate = !this.props.showGlobal || (this.props.showGlobal && this.props.chart.useGlobal) ? moment(this.props.analyticsDatePicker.globalToTime) : moment(this.props.chart.toTime);
    return (
            <div className="PresetDateRangePicker_panel">
                    {presets.map(({text, start, end, presetDate}, index) => {
                            const isSelected = isSameDay(start, startDate) && isSameDay(end, endDate);
                            return (
                                    <button
                                            key={index}
                                            className={"PresetDateRangePicker_button " + (isSelected ? "PresetDateRangePicker_button__selected" : "")
                                            }
                                            type="button"
                                            onClick={() => {
                                                    this.props.onPresetDateSelected(start, end, presetDate);
                                                    this.props.onFocusChange(null);
                                            }}
                                    >{text}
                                    </button>
                            );
                    })}
                    {this.props.showGlobal &&
                    <button
                            className={"PresetDateRangePicker_button "+ (this.props.chart.useGlobal ? "PresetDateRangePicker_button__selected" : "")}
                            type="button"
                            onClick={() => {
                                    this.props.onGlobalSelected();
                                    this.props.onFocusChange(null);
                            }}
                    ><FormattedMessage id="Use Global"/>
                    </button>
                    }
            </div>
        );
    }
}